// removed by extract-text-webpack-plugin
module.exports = {"root":"root___qV8Io"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Operation/ChargeItem/Modal/Delay.less
// module id = PzI9
// module chunks = 13